import React from "react";

const SvgSortingDown = props => (
  <svg viewBox="0 0 238 209" {...props}>
    <g data-name="Vrstva 2">
      <g data-name="Obecn\xE9 ikony">
        <g data-name="Sorting down">
          <path data-name="&lt;\u0158ez&gt;" fill="none" d="M0 0h238v209H0z" />
          <path
            data-name="Sorting down"
            d="M52.7 197.58a7.31 7.31 0 01-5.13-2.13h-.09l-.08-.13-35.82-35.38a7.35 7.35 0 01-.09-10.46 7.36 7.36 0 0110.43-.09l23.38 23.07.22-152.79a7.4 7.4 0 0114.79 0l-.22 152.61L83 148.94a7.4 7.4 0 0110.56 10.38L58 195.36a7.43 7.43 0 01-2.41 1.64 7.25 7.25 0 01-2.76.58zm80.05-21.38a7.13 7.13 0 110-14.25h89.4a7.13 7.13 0 110 14.25zm0-42.76a7.13 7.13 0 110-14.25h89.4a7.13 7.13 0 110 14.25zm-33.5-42.76a7.13 7.13 0 110-14.26h122.9a7.13 7.13 0 010 14.26zm0-42.76a7.13 7.13 0 110-14.26h122.9a7.13 7.13 0 010 14.26z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SvgSortingDown;
